import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import LanguageSelector from "./LanguageSelector";

export default function NeokittyWhitepaper() {
  const { i18n, t } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    if (lang && ["en", "es", "ru", "zh"].includes(lang)) {
      i18n.changeLanguage(lang);
    } else if (!localStorage.getItem("i18nextLng")) {
      i18n.changeLanguage("en").catch(() => {});
    }
  }, [lang, i18n]);

  const rawWp = t("wp", { returnObjects: true });
  const wp =
    rawWp && typeof rawWp === "object" && !Array.isArray(rawWp)
      ? rawWp
      : null;

  const currentLang = i18n.language || "en";

  const titles = {
    en: "WHITEPAPER",
    es: "WHITEPAPER",
    ru: "БЕЛАЯ КНИГА",
    zh: "白皮书"
  };

  const backToHome = currentLang === "en" ? "/" : `/${currentLang}`;

  return (
    <>
      <Helmet>
        <html lang={currentLang} />
        <title>NeoKitty Whitepaper</title>
        <meta
          name="description"
          content="Official NeoKitty whitepaper"
        />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-[#071029] via-[#071a3a] to-[#04233f] text-white antialiased">
        <LanguageSelector />

        {/* HEADER */}
        <header className="max-w-6xl mx-auto px-6 py-10 flex flex-col items-center">
          <img
            src="/assets/logo-neokitty.png"
            alt="Neokitty Logo"
            className="w-[200px] h-[200px] object-contain drop-shadow-[0_0_16px_#00E6FF60]"
          />

          <h1 className="mt-6 text-4xl md:text-5xl font-extrabold text-center drop-shadow-[0_0_18px_#00E6FF70]">
            {titles[currentLang] || "WHITEPAPER"}
          </h1>

          <p className="mt-3 text-sm text-slate-300 text-center">
            NeoKitty — The Meme Gaming Token
          </p>
        </header>

        {/* CONTENT */}
        <main className="max-w-4xl mx-auto px-6 pb-20 text-slate-200 leading-relaxed space-y-14">
          {!wp && (
            <p className="text-center text-slate-400">
              Loading whitepaper…
            </p>
          )}

          {wp &&
            Object.keys(wp)
              .sort((a, b) => Number(a) - Number(b))
              .map((key) => {
                const section = wp[key];

                return (
                  <section key={key}>
                    <h2 className="text-2xl font-bold mb-4 text-white">
                      {key}. {section.title}
                    </h2>

                    {section.p1 && <p className="mb-4">{section.p1}</p>}
                    {section.p2 && <p className="mb-4">{section.p2}</p>}

                    {(section.li1 || section.li2) && (
                      <ul className="list-disc list-inside space-y-2 mt-4 text-slate-300">
                        {section.li1 && <li>{section.li1}</li>}
                        {section.li2 && <li>{section.li2}</li>}
                        {section.li3 && <li>{section.li3}</li>}
                        {section.li4 && <li>{section.li4}</li>}
                      </ul>
                    )}
                  </section>
                );
              })}
        </main>

        {/* FOOTER */}
        <footer className="max-w-6xl mx-auto px-6 pb-14 text-center">
          <a
            href={backToHome}
            className="inline-flex items-center gap-2 px-6 py-3 border border-white/20 rounded-xl font-semibold hover:bg-white/10 transition shadow-[0_0_12px_#00E6FF40]"
          >
            ← {t("common.back_home")}
          </a>
        </footer>
      </div>
    </>
  );
}
